import React from 'react';

import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { Box, Chip, Stack } from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import { scroll } from 'common/utils/mixins';

import FieldArray from './FieldArray'; // Renombramos ReduxFieldArray a FieldArray

const CategoryWrapper = styled(Box)`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding-bottom: 8px;
    padding-top: 16px;
    width: 100%;
`;

const PermissionWrapper = styled(Box)`
    display: flex;
    flex-direction: column;
    height: 400px;
    overflow-y: scroll;
    padding-right: 8px;
    width: 100%;
    ${scroll.custom()}
`;

const StyledChip = styled(Chip)(({ theme }) => ({
    '&.MuiChip-outlined': {
        borderColor: '#1f3c53',
        color: theme.palette.mode === 'dark' ? '#ff9a00' : '#1f3c53',
        textTransform: 'capitalize',
        fontWeight: 600,
        '&.selected, &:focus, &:hover': {
            backgroundColor:
                theme.palette.mode === 'dark' ? '#ff9a00' : 'rgb(169,181,192)',
            color: theme.palette.mode === 'dark' ? '#ffffff' : '#1f3c53',
        },
    },
}));

const PermissionList = ({
    control, // Añadimos control como prop desde el formulario padre
    formValues,
    isDisabled,
    isFetching,
    roleLevel,
    setValue,
}) => {
    if (isFetching)
        return (
            <Box sx={{ width: '100%' }}>
                <LinearProgress />
            </Box>
        );

    const categories = get(formValues, 'categories', []);

    return (
        <Stack>
            <CategoryWrapper>
                {categories.map((item) => (
                    <StyledChip
                        className={
                            item.id === formValues?.category ? 'selected' : ''
                        }
                        key={`chip-${item.id}`}
                        label={item?.name?.toLowerCase()}
                        onClick={() => setValue('category', item?.id)} // Usamos setValue en lugar de changeInput
                        variant="outlined"
                    />
                ))}
            </CategoryWrapper>

            <PermissionWrapper>
                <FieldArray
                    control={control} // Pasamos control a FieldArray
                    category={formValues?.category}
                    disabled={isDisabled}
                    formValues={formValues}
                    name="groups" // Nombre del campo array
                    roleLevel={roleLevel}
                />
            </PermissionWrapper>
        </Stack>
    );
};

PermissionList.propTypes = {
    control: PropTypes.object.isRequired, // Añadimos control como prop requerido
    formValues: PropTypes.object,
    isDisabled: PropTypes.bool,
    isFetching: PropTypes.bool,
    roleLevel: PropTypes.object,
    setValue: PropTypes.func.isRequired, // Añadimos setValue como prop requerido
};

export default PermissionList;
